<template>
  <div v-show="display" class="player-container">
    <PlayerPanel />
    <PgnnpAudioAd v-if="pgnnpAudioMask" />
    <div id="player" ref="player" class="player">
      <audio id="audioPlayer" ref="audioPlayer">
        <!-- <source src="@/assets/.tmp/test-1.mp3" type="audio/mpeg" > -->
        <p>Your browser doesn't support HTML5 audio. </p>
      </audio>
      <div class="player-wrapper">
        <PlayerProgressBar :play="play" :pause="pause" :set-current-time="setCurrentTime"
                           :duration="duration" :current-time="currentTime" :disabled="pgnnpAudioMode"
        />
        <div class="player-board">
          <div class="info">
            <PlayerTrackInfo :track="currentTrack" :translate="true" :disabled-click="pgnnpAudioMode" />
          </div>
          <div v-if="!pgnnpAudioMode" class="control">
            <div class="control-item volume">
              <PlayerVolumeBtn />
            </div>
            <div class="control-item repeat">
              <PlayerRepeatBtn />
            </div>
            <div class="control-item time">
              {{ currentTime | playerTime }} / {{ duration | playerTime }}
            </div>
            <div :class="{'disabled': random || currentIndex === 0}" class="control-item player-icon prev">
              <i :class="rotatePanelIcon" class="material-icons" @click="togglePrevious()">
                skip_previous
              </i>
            </div>
            <div class="control-item play-arrow">
              <PlayerPlayBtn v-if="!loading" :width="40" :height="40" :type="'static'" @click="togglePlay()" />
              <Loader v-else :width="40" :height="40" />
            </div>
            <div :class="{'disabled':currentIndex === queue.length - 1}" class="control-item player-icon next">
              <i :class="rotatePanelIcon" class="material-icons" @click="toggleNext()">
                skip_next
              </i>
            </div>
            <div class="control-item panel-arrow">
              <a title="toggle panel" class="toggle-panel" @click="togglePanel()">
                <i :class="rotatePanelIcon" class="arrow material-icons">
                  keyboard_arrow_up
                </i>
              </a>
            </div>
          </div>
          <div v-else class="control">
            <div class="control-item player-icon disabled">
              <i :class="rotatePanelIcon" class="material-icons">
                skip_previous
              </i>
            </div>
            <div class="control-item play-arrow">
              <PlayerPlayBtn v-if="!loading" :width="40" :height="40" :type="'round'" :disabled="'disabled'" />
              <Loader v-else :width="40" :height="40" />
            </div>
            <div class="control-item player-icon disabled">
              <i :class="rotatePanelIcon" class="material-icons">
                skip_next
              </i>
            </div>
            <div class="control-item panel-arrow disabled">
              <a title="toggle panel ">
                <i :class="rotatePanelIcon" class="arrow material-icons">
                  keyboard_arrow_up
                </i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { displayTrackName } from '@/assets/helpers/TrackHelper.js'
import { getCookie, setCookie } from '@/assets/helpers/UtilHelper'

import Loader from '@/components/common/Loader'
import PlayerPanel from '@/components/player/PlayerPanel'
import PlayerPlayBtn from '@/components/player/PlayerPlayBtn'
import PlayerRepeatBtn from '@/components/player/PlayerRepeatBtn'
import PlayerVolumeBtn from '@/components/player/PlayerVolumeBtn'
import PlayerTrackInfo from '@/components/player/PlayerTrackInfo'
import PlayerProgressBar from '@/components/player/PlayerProgressBar'

import LoggerService from '@/assets/services/LoggerService'
import PgnnpAudioAd from '@/components/tsp/PgnnpAudioAd'

export default {
  name: 'MuzikPlayer',
  components: {
    Loader,
    PlayerProgressBar,
    PlayerTrackInfo,
    PlayerVolumeBtn,
    PlayerRepeatBtn,
    PlayerPlayBtn,
    PlayerPanel,
    PgnnpAudioAd
  },
  filters: {
    playerTime(value) {
      let hour = ''
      let minute = '00'
      let second = '00'
      if (value >= 3600) {
        hour = Number.parseInt(value / 3600)
        hour = hour < 10 ? `0${hour}` : hour
        value = value % 3600
      }
      if (value >= 60) {
        minute = Number.parseInt(value / 60)
        minute = minute < 10 ? `0${minute}` : minute
        value = value % 60
      }
      if (value > 0) {
        second = Number.parseInt(value)
        second = second < 10 ? `0${second}` : second
      }
      return hour ? `${hour}:${minute}:${second}` : `${minute}:${second}`
    }
  },
  props: {},
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      // Namespacing
      initialClick: state => state.player.initialClick,
      loading: state => state.player.loading,
      display: state => state.player.display,
      displayPanel: state => state.player.panel,
      currentIndex: state => state.player.index,
      currentTrackId: state => state.player.trackId,
      currentTrack: state => state.player.track,
      random: state => state.player.random,
      pool: state => state.player.pool,
      queue: state => state.player.queue,
      paused: state => state.player.paused,
      volume: state => state.player.volume,
      repeat: state => state.player.repeat,
      currentTime: state => state.player.currentTime,
      duration: state => state.player.duration,
      ended: state => state.player.ended,
      pgnnpAudioMode: state => state.player.pgnnpAudioMode,
      pgnnpAudioMask: state => state.player.pgnnpAudioMask,
      isPrependToPool: state => state.player.isPrependToPool,
      isAnyPgnnpAudio: state => state.player.isAnyPgnnpAudio,
      playingCount: state => state.player.playingCount,
      playingInterval: state => state.player.playingInterval
    }),
    ...mapGetters([]),
    rotatePanelIcon() {
      return this.displayPanel ? 'rotated' : ''
    }
  },
  watch: {
    display(newValue) {
      if (newValue) {
        // do nothing
      } else {
        // close player
        this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
      }
    },
    paused(newValue) {
      // console.log('Player paused updated', newValue)
      if (!newValue) {
        this.play()
      } else {
        this.pause()
      }
    },
    currentIndex(newValue, oldValue) {
      // console.log(`Player currentIndex updated ${oldValue} => ${newValue}`)
      if (this.queue[newValue] && this.queue[oldValue] && this.queue[newValue].id === this.queue[oldValue].id) {
        // console.log('Same track id, reset current time.')
        this.setCurrentTime(0)
      }
    },
    currentTrackId(newValue, oldValue) {
      // console.log('Player currentTrackId updated', this.displayTrackName(this.currentTrack))
      // console.log(`Player paused ${this.paused}`)
      this.load()
      if (!this.paused) {
        this.play() // load new track and play
      } else {
        // do nothing
      }
    },
    volume(newValue) {
      this.updateVolume(newValue)
    }
  },
  created() {},
  updated() {},
  mounted() {
    if (!this.$isMobile) {
      // window.addEventListener('keydown', this.keyboardControl)
    }
    this.$refs.audioPlayer.onloadeddata = this.onLoadedData
    this.$refs.audioPlayer.ontimeupdate = this.onTimeUpdate
    this.$refs.audioPlayer.onended = this.onEnded
    this.$refs.audioPlayer.oncanplay = this.onCanplay
    this.$refs.audioPlayer.onloadstart = this.onLoadStart
    // No use below
    // this.$refs.audioPlayer.onplay = () => { console.log('onplay') }
    // this.$refs.audioPlayer.onplaying = () => { console.log('onplaying') }
    // this.$refs.audioPlayer.onpause = () => { console.log('onpause') }
    // this.$refs.audioPlayer.onprogress = () => { console.log('onprogress') }
    // this.$refs.audioPlayer.onwaiting = () => { console.log('onwaiting') }

    // Log
    window.addEventListener('beforeunload', this.beforeunload)
  },
  beforeDestroy() {
    // window.removeEventListener('keydown', this.keyboardControl)
    window.removeEventListener('beforeunload', this.beforeunload)
  },
  methods: {
    displayTrackName,
    getCookie,
    setCookie,
    beforeunload(e) {
      if (!this.paused && this.currentTrackId && this.currentTime && this.duration) {
        // console.log('log beforeunload')
        this.logRecord(this.currentTime, 'close')
      }
    },
    load() {
      if (this.currentTrackId && this.currentTrack['file_link']) {
        this.$refs.audioPlayer.src = this.currentTrack['file_link']
        this.$refs.audioPlayer.load() // check in onloadeddata
      } else if (this.currentTrackId && !this.currentTrack['file_link']) {
        // console.error('No file link in current track data...')
      } else {
        // console.log('No current track...')
      }
    },
    play() {
      if (this.currentTrack && this.currentTrack.id) {
        const promise = this.$refs.audioPlayer.play()
        if (promise !== undefined) {
          promise
            .then(() => {
              // play
            })
            .catch(error => {
              // console.log('error')
              // this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
              // console.log('promise error', error)
              // Auto-play was prevented
              // Show a UI element to let the user manually start playback
              if (error.name && error.name === 'NotAllowedError') {
                this.$store.commit('ALERT_MESSAGE', { message: 'PLAYER.AUTO_PLAY_WAS_PREVENTED', type: 'error', duration: 6000 })
                this.$nextTick(() => {
                  this.$store.commit('ALERT_MESSAGE', { message: 'PLAYER.ALLOW_AUTO_PLAY', type: 'error', duration: 6000 })
                })
              }
            })
        }
      } else {
        // console.log('No currentTrack.')
        this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
      }
    },
    pause() {
      this.$refs.audioPlayer.pause()
    },
    canPlayType(type) {
      this.$refs.audioPlayer.canPlayType(type)
    },
    fastSeek(time) {
      // Firefox only
      this.$refs.audioPlayer.fastSeek(time)
    },
    muted() {
      this.$refs.audioPlayer.muted = !this.$refs.audioPlayer.muted
    },
    volumeUp(offset = 0.1) {
      if (this.$refs.audioPlayer.volume < 1) {
        this.$refs.audioPlayer.volume += offset
      }
    },
    volumeDown(offset = 0.1) {
      // JS floating overflow problem
      if (Number.parseFloat(this.$refs.audioPlayer.volume).toFixed(2) > 0.01) {
        this.$refs.audioPlayer.volume -= offset
      }
    },
    updateVolume(value) {
      this.$refs.audioPlayer.volume = value
    },
    setCurrentTime(newCurrentTime) {
      this.$refs.audioPlayer.currentTime = newCurrentTime
    },
    onCanplay() {
      this.$store.commit('UPDATE_LOADING', false)
    },
    onLoadStart() {
      this.$store.commit('UPDATE_LOADING', true)
    },
    onLoadedData() {
      this.updatePlayerInfo()
    },
    onTimeUpdate() {
      if (!this.paused && this.currentTime === 0 && this.initialClick) {
        this.logRecord(this.currentTime, 'play')
      }
      if (!this.paused) {
        this.updatePlayerInfo() // after logging first time
      }
    },
    async onEnded() {
      // Increase playcount and check if needs to insert audio ad
      await this.$store.dispatch('INCREASE_PLAYING_COUNT')
      // API definition, continue playing action 'play'
      this.logRecord(this.currentTime, 'play')

      if (this.random) {
        if (this.playingCount % this.playingInterval === 0) {
        } else {
          this.$store.dispatch('RANDOM_NEXT')
        }
        if (this.pgnnpAudioMode) {
          this.$store.dispatch('PGNNP_AUDIO_ENDED')
        }
        this.$store.commit('PGNNP_AUDIO_MODE', false)
        this.$store.commit('PGNNP_AUDIO_MASK', false)
      } else {
        // AD ended and send session to PGNNP
        if (this.pgnnpAudioMode) {
          this.$store.dispatch('PGNNP_AUDIO_ENDED')
        }

        // Normal playing
        if (this.repeat === 2) {
          this.$store.commit('SET_PLAYER_INDEX', this.currentIndex)
          // this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
          this.$nextTick(() => {
            this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
            this.setCurrentTime(0)
            this.play()
          })
        } else {
          let nextIndex = this.currentIndex + 1
          if ((this.playingCount === 1 && this.isAnyPgnnpAudio) || this.pgnnpAudioMode) {
            nextIndex--
          }
          if (this.repeat === 1) {
            nextIndex = nextIndex % this.queue.length
          }
          if (nextIndex < this.queue.length) {
            if (this.playingCount % this.playingInterval === 0) {
            } else {
              this.$store.commit('SET_PLAYER_INDEX', nextIndex)
            }
            this.$nextTick(() => {
              // console.log('In repeat mode', this.repeat, 'auto continue playing.')
              this.$store.commit('TOGGLE_PLAYER_PAUSED', false)
            })
          } else if (this.pgnnpAudioMode) {
            // console.log('Totally ended and after AD audio.')
            this.$store.commit('SET_PLAYER_INDEX', 0)
            this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
          } else {
            // console.log('Totally ended.')
            if (this.currentIndex !== 0) {
              this.$store.commit('SET_PLAYER_INDEX', 0)
            } else {
              this.setCurrentTime(0)
            }
            this.$store.commit('TOGGLE_PLAYER_PAUSED', true)
            this.updatePlayerInfo()
          }
        }
        this.$store.commit('PGNNP_AUDIO_MODE', false)
        this.$store.commit('PGNNP_AUDIO_MASK', false)
      }
    },
    logRecord(loggingTime, action) {
      const params = {
        userId: this.$store.getters.getProfile.id || '',
        peopleCookieId: window.localStorage.getItem('fingerprint') || '',
        trackId: this.currentTrackId || '',
        scenarioId: '',
        playlistId: '',
        refer: document.referrer || this.$route.query.refer || '',
        currentTime: Number.parseInt(loggingTime),
        duration: Number.parseInt(this.duration),
        agent: window.navigator.userAgent,
        action: action
      }
      LoggerService.logUserListenAction(params)
    },
    togglePlay() {
      const isFirst = this.isFirstPlay()
      if (isFirst) {
        this.$store.commit('SET_TO_PREPEND', true)
        this.$store.dispatch('PGNNP_AUDIO_NEXT')
        if (!this.isAnyPgnnpAudio) {
          document.querySelector('#audioPlayer').play()
          document.querySelector('#audioPlayer').pause()
        }
      } else if (!this.initialClick) {
        // Trigger click-to-play policy
        document.querySelector('#audioPlayer').play()
        document.querySelector('#audioPlayer').pause()
      }
      this.$nextTick(() => {
        this.$store.commit('TOGGLE_PLAYER_PAUSED', !this.paused)
      })
    },
    togglePanel() {
      this.$store.commit('TOGGLE_PLAYER_PANEL')
    },
    togglePrevious() {
      if (!this.random && this.currentIndex > 0) {
        this.$store.commit('SET_PLAYER_INDEX', this.currentIndex - 1)
        if (!this.paused) {
          this.logRecord(this.currentTime, 'previous')
        }
      }
    },
    async toggleNext() {
      if (!this.paused) {
        this.$store.dispatch('INCREASE_PLAYING_COUNT')
      }
      if (!this.random && this.currentIndex < this.queue.length - 1) {
        this.$store.commit('SET_PLAYER_INDEX', this.currentIndex + 1)
        if (!this.paused) {
          this.logRecord(this.currentTime, 'next')
        }
      } else if (this.random) {
        if (this.playingCount % this.playingInterval === 0) {
        } else {
          this.$store.dispatch('RANDOM_NEXT')
        }
      }
    },
    updatePlayerInfo() {
      const playerInfo = {
        src: this.$refs.audioPlayer.src,
        currentSrc: this.$refs.audioPlayer.currentSrc,
        autoplay: this.$refs.audioPlayer.autoplay,
        duration: this.$refs.audioPlayer.duration,
        currentTime: this.$refs.audioPlayer.currentTime,
        controls: this.$refs.audioPlayer.controls,
        loop: this.$refs.audioPlayer.loop,
        muted: this.$refs.audioPlayer.muted,
        defaultMuted: this.$refs.audioPlayer.defaultMuted,
        volume: this.$refs.audioPlayer.volume,
        seeking: this.$refs.audioPlayer.seeking,
        paused: this.$refs.audioPlayer.paused,
        ended: this.$refs.audioPlayer.ended
      }
      this.$store.commit('UPDATE_PLAYER_INFO', playerInfo)
    },
    keyboardControl(e) {
      if (this.display) {
        if (e.keyCode === 37) {
          // left
          const newCurrentTime = this.currentTime - 10
          this.setCurrentTime(newCurrentTime)
        } else if (e.keyCode === 39) {
          // right
          const newCurrentTime = this.currentTime + 10
          this.setCurrentTime(newCurrentTime)
        } else if (e.keyCode === 32) {
          // space
          this.togglePlay()
        }
      }
    },
    async increasePlayCount() {
      let playCount = this.playingCount ? this.playingCount + 1 : 1
      this.setCookie('player_play_count', playCount)
      this.$store.commit('SET_PLAYING_COUNT', playCount)
    },
    checkInsertAudioAD() {
      return (this.playingCount % this.playingInterval === 0)
    },
    isFirstPlay() {
      return (this.getCookie('player_play_count') === null)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@keyframes player-slide-up {
  0% {
    bottom: -195px;
    opacity: 0;
  }
  100% {
    bottom: 0;
    opacity: 1;
  }
}
.player-container {
  z-index: 99;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  animation: player-slide-up 1s 0s 1 linear;
}
.player {
  position: relative;
  height: 65px;
  width: 100%;
  border-radius: 0;
  box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.27);

  &-board {
    position: absolute;
    bottom: 0;
    height: 59px;
    width: 100%;
    background-color: #ffffff;
    padding: 0 24px;
    overflow: hidden;
    .info,
    .control {
      height: 59px;
      display: inline-block;
      vertical-align: top;
    }
    .info {
      width: calc(100% - 575px);
    }
    .control {
      float: right;
      width: 575px;
      text-align: right;
      user-select: none;
      &::before {
        content: '';
        width: 0;
        height: 100%;
        display: inline-block;
        position: relative;
        vertical-align: middle;
      }
      > * {
        display: inline-block;
        vertical-align: middle;
      }
      &-item {
        margin-left: 24px;
        color: $grey-9b;
        font-weight: 700;
      }
      &-item.player-icon,
      &-item.volume,
      &-item.repeat {
        height: 24px;
      }
      &-item.player-icon {
        cursor: pointer;
        color: $grey-7d;
        &.disabled {
          cursor: not-allowed;
          color: $grey-ec;
        }
        @media (hover: hover) {
          &:hover {
            color: $grey-9b;
          }
          &.disabled {
            color: $grey-ec;
          }
        }
      }
      &-item.time {
        min-width: 105px;
        font-size: 16px;
      }
      &-item.play-arrow {
        height: 40px;
      }
      &-item.panel-arrow {
        height: 36px;
        cursor: pointer;
        .arrow {
          font-size: 36px;
          transition: transform 0.4s ease;
        }
        .arrow.rotated {
          transform: rotate(180deg);
        }
        &.disabled {
          cursor: not-allowed;
          color: $grey-ec;
        }
      }
    }
  }
}
@media only screen and (min-width: 1440px) {
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
}
@media only screen and (max-width: 767.98px) {
  .player {
    &-board {
      padding: 0 8px;
      .info {
        width: calc(100% - 125px);
      }
      .control {
        width: 125px;
        &-item {
          margin-left: 8px;
        }
        &-item.player-icon,
        &-item.volume,
        // &-item.repeat,
        &-item.time {
          display: none;
        }
      }
    }
  }
}
</style>
